import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfBrush, PdfColor, ETextAlign } from '../../pdf/pdf';
import { ILayoutLabelGen } from '../layoutLabel';
import { OptsLabel } from '../optsLabel';
import { GUtil } from '../../pdf/gutil';
import { calcOrigin } from '../../core/genHelper';
import { placeObjects } from '../../core/placeObjects';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/helpers';
import '../../pdf/draw/arrow';
import '../../pdf/draw/label';

import { IItemCount } from '@educraft/base';

export class HraOkolo implements ILayoutLabelGen, IItemCount {
  countDefault(): number {
    return 13;
  }
  countMin(): number {
    return 13;
  }
  countMax(): number {
    return 13;
  }

  public async generate(pdf: PdfGen, opts: OptsLabel): Promise<void> {
    const itemsPerPage = 13;
    const {list} = opts;

    for (let sIdx = 0; sIdx < list.length; sIdx += itemsPerPage) {
      const page = pdf.addPage();
      const currentItems = list.slice(sIdx, sIdx + itemsPerPage);
      if (currentItems.length === 0) break;

      const margin = PdfUnit.FromMillimeters(5);
      const countX = 4;
      const countY = 5;
      const arrowSize = new PdfSize(PdfUnit.FromMillimeters(10), PdfUnit.FromMillimeters(10));

      const { origin, size } = calcOrigin(countX, countY, margin, PdfSize.A4);

      const smallSize = new PdfSize(size.width / 3, size.height / 3);

      const background = new PdfBrush(PdfColor.fromRgb(255, 255, 230));
      const redBrush = new PdfBrush(PdfColor.fromHex('#FF0000'));

      const {lang} = opts.data;
      const startLabel = (lang && (lang.Generator_Start ?? lang.start)) ?? 'START';

      // Measure font for edge items (left labels)
      const edgeTexts = currentItems.map((i) => [i.left.getText()]);
      const f = page.adjustFontMulti(
        edgeTexts,
        GUtil.baseFont,
        new PdfSize(size.width * 0.9, size.height * 0.9)
      );

      let index = 0;

      const getRect = (x: number, y: number) =>
        new PdfRect(origin.x + x * size.width, origin.y + y * size.height, size.width, size.height);

      const drawCell = (x: number, y: number) => {
        if (index >= currentItems.length) return;
        const r = getRect(x, y);
        const item = currentItems[index];
        page.drawRectangle(null, background, r);
        page.drawRectangle(GUtil.basePen, null, r);
        page.drawLabel(item.left, { rect: r, font: f });
        index++;
      };

      for (let x = 1; x < countX; x++) drawCell(x, 0);
      for (let y = 1; y < countY; y++) drawCell(countX - 1, y);
      for (let x = countX - 2; x >= 0; x--) drawCell(x, countY - 1);
      for (let y = countY - 2; y > 0; y--) drawCell(0, y);

      const r12 = getRect(0, 0);
      const r1 = new PdfRect(r12.x, r12.y, size.width, size.height / 2);
      const r2 = new PdfRect(r1.x, r1.y + r1.height, r1.width, r1.height);

      page.drawRectangle(GUtil.basePen, null, r1);
      page.drawString(startLabel, GUtil.baseFont, PdfBrush.Black, null, r1, ETextAlign.Center);

      page.drawRectFinish(r2);

      const a1 = new PdfRect(
        r1.right - arrowSize.width / 2,
        r1.y + (r1.height - arrowSize.height) / 2,
        arrowSize.width,
        arrowSize.height
      );
      const a2 = new PdfRect(
        r2.x + (r2.width - arrowSize.width) / 2,
        r2.bottom - arrowSize.height / 2,
        arrowSize.width,
        arrowSize.height
      );

      page.drawArrowRight(a1, redBrush);
      page.drawArrowUp(a2, redBrush);

      const centerRect = new PdfRect(
        origin.x + size.width,
        origin.y + size.height,
        size.width * (countX - 2),
        size.height * (countY - 2)
      );

      // Measure font for center items (right labels)
      const answerTexts = currentItems.map((i) => [i.right.getText()]);
      const answerFont = page.adjustFontMulti(
        answerTexts,
        GUtil.baseFont,
        new PdfSize(smallSize.width * 0.9, smallSize.height * 0.9)
      );

      const placed = placeObjects(opts.data.random, centerRect, smallSize, currentItems);

      for (const obj of placed) {
        if (!obj.data) continue;
        page.drawLabel(obj.data.right, { rect: obj.rect, font: answerFont });
      }
    }
  }
}
